/*
|
|               Project
_______________________________________________
|
|    This class keep all fields for 
|    new project.
|
*/

export class Project {
    attachment                :any     = '';
    attachment_public_id      :any     = '';
    BuildingType              :string  = '';
    City                      :string  = '';
    comission_amount          :any     = '';
    comission_paid?           :any     = 'false';
    Contact                   :string  = '';
    ConsultationFee           :number  = 0;
    Country                   :string  = '';
    Customer                  :any     = '';
    customRebates             :boolean = false;
    deadline?                 :any     = '';
    DepositPercentage         :number  = 30;
    document                  :string  = '';
    InstallationCost          :any;            // Labor Cost Override
    InstallationCostA         :any     = '';
    InstallationCostB         :any     = '';
    InstallationCostC         :any     = '';
    shippingCost              :string  = '';
    shippingCostA             :string  = '';
    shippingCostB             :string  = '';
    shippingCostC             :string  = '';
    Discount                  :number  = 0;
    DiscountA                 :number  = 0;
    DiscountB                 :number  = 0;
    DiscountC                 :number  = 0;
    optionNameA               :string  = '';
    optionNameB               :string  = '';
    optionNameC               :string  = '';
    electricBill              :string  = '';
    ElectricityPrice          :number;
    Email                     :string  = '';
    floorPlan                 :string  = '';
    jobDetails                :any     = '';
    jobType                   :string  = '';
    id                        :any     = '';
    importDuties              :number  = 0;
    insuranceCost             :number  = 0;
    months_cooling            :number  = 4.6;
    Maintenance               :number  = 0;
    Name                      :string  = '';
    newInstallation           :boolean = true;
    Notes                     :string  = '';
    owner                     :any     = '';
    PhoneNumber               :string  = '';
    Position                  :any     = '';
    productCostOverride       :string  = '';
    Profit                    :string;
    Rebates?                  :number[] = [];
    Sales                     :number;
    shippingDetails           :any     = '';
    showMaintenanceSavings    :boolean = true;
    showManufacturer          :boolean = true;
    showSKU                   :boolean = true;
    showProductCost           :boolean = true;
    State                     :string  = 'NY';
    status                    :string  = 'newLead';
    Street                    :string  = '';
    SquareFootage             :number  = 0;
    Tax                       :number  = 8.875;
    tax_id                    :any;
    video_before?             :string[];
    video_after?              :string;
    videos                    :any[]   = [ { name: '', before: '', after: '' } ];
    ZipCode                   :string  = '';
    initial_option            :string  = '';
}



// WEBPACK FOOTER //
// /root/anvel/angular/classes/Project.ts